import './styles/app.scss'
import BeetAPI from '@boite-beet/api-client'
import { createApp } from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { Vue3Mq } from 'vue3-mq'

import App from '@/App.vue'
import reveal from '@/extensions/reveal/index.js'
import router from '@/router'
import store from '@/store'

const app = createApp(App)
  .use(store)
  .use(router)
  .use(BeetAPI, { store, apiUrl: import.meta.env.VITE_APP_API_URL })
  .use(reveal)
  .use(Vue3Mq, {
    breakpoints: {
      base: 0,
      sm: 566,
      md: 1024,
      lg: 1360,
      xl: 1440,
    },
    global: true,
  })
  .use(VueReCaptcha, { siteKey: import.meta.env.VITE_APP_RECAPTCHA_KEY })

app.mount('#app')
